import React, { memo, useEffect, useRef } from "react";
import { Animated, View, } from "react-native";
import { styles } from "./OtpInput.styles";
export const VerticalStick = memo(({ focusColor, style, focusStickBlinkingDuration = 350 }) => {
    const opacityAnim = useRef(new Animated.Value(1)).current;
    useEffect(() => {
        Animated.loop(Animated.sequence([
            Animated.timing(opacityAnim, {
                toValue: 0,
                useNativeDriver: true,
                duration: focusStickBlinkingDuration,
            }),
            Animated.timing(opacityAnim, {
                toValue: 1,
                useNativeDriver: true,
                duration: focusStickBlinkingDuration,
            }),
        ]), {
            iterations: -1,
        }).start();
    }, []);
    return (React.createElement(Animated.View, { style: { opacity: opacityAnim } },
        React.createElement(View, { style: [
                styles.stick,
                focusColor ? { backgroundColor: focusColor } : {},
                style,
            ] })));
});
